<div class="column">
    <input type="text" pattern="[0-9]*" min="0" max="360" [value]="value?.getHue().toString()" (inputChange)="onInputChange($event, 'H')" />
    @if (labelVisible()) {
        <span>H</span>
    }
</div>
<div class="column">
    <input type="text" pattern="[0-9]*" min="0" max="100" [value]="value?.getSaturation() + '%'" (inputChange)="onInputChange($event, 'S')" />
    @if (labelVisible()) {
        <span>S</span>
    }
</div>
<div class="column">
    <input type="text" pattern="[0-9]*" min="0" max="100" [value]="value?.getLightness() + '%'" (inputChange)="onInputChange($event, 'L')" />
    @if (labelVisible()) {
        <span>L</span>
    }
</div>
@if (isAlphaVisible()) {
    <div class="column">
        <input type="text" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" [value]="value?.getAlpha().toString()" (inputChange)="onInputChange($event, 'A')" />
        @if (labelVisible()) {
            <span>A</span>
        }
    </div>
}